module.exports = __webpack_public_path__ + "media/definite-555.mp3";